import * as XLSX from "xlsx";

/**
 * Exporta uma lista de objetos (linhas) para um arquivo .xlsx e dispara o download.
 * As chaves do primeiro objeto viram o cabeçalho da planilha.
 *
 * @param {Array<Object>} rows - linhas a exportar (array de objetos)
 * @param {string} filename - nome do arquivo, SEM a extensão
 * @param {string} [sheetName="Dados"] - nome da aba
 */
export const exportToExcel = (rows, filename, sheetName = "Dados") => {
  const ws = XLSX.utils.json_to_sheet(rows);

  // Largura automática simples por coluna (baseada no maior conteúdo)
  if (rows.length > 0) {
    const cols = Object.keys(rows[0]).map((key) => {
      const maxLen = Math.max(
        key.length,
        ...rows.map((r) => String(r[key] ?? "").length)
      );
      return { wch: Math.min(Math.max(maxLen + 2, 10), 60) };
    });
    ws["!cols"] = cols;
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  XLSX.writeFile(wb, `${filename}.xlsx`);
};
